import styled from "styled-components";
import { StyledTextAreaProps } from "./types";
import { ANIMATION, QUERIES } from "../../../utils/constants";

export const TextAreaWrapper = styled.div`
  width: 100%;
`;

export const TextAreaFieldWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const StyledTextArea = styled.textarea<StyledTextAreaProps>`
  width: 100%;
  min-height: ${(props) => props.$minHeight}px;
  padding: 0.75rem;
  border: 1px solid
    ${(props) => (props.$error ? "var(--color-error-border)" : "var(--color-gray-border)")};
  border-radius: 0.5rem;
  font-size: var(--text-base);
  font-family: inherit;
  line-height: 1.5;
  color: var(--color-text-default);
  background: var(--color-card-background);
  resize: vertical;
  transition: ${ANIMATION.transitions.all};

  &:hover:not(:disabled):not(:focus) {
    border-color: ${(props) => (props.$error ? "var(--color-error-hover)" : "var(--color-primary)")};
    background: var(--hover-background);
  }

  &:focus {
    outline: none;
    border-color: ${(props) => (props.$error ? "var(--color-error-border)" : "var(--color-primary)")};
    box-shadow: var(--shadow-focus);
  }

  &:disabled {
    color: var(--color-text-muted);
    background: var(--color-background-disabled);
    border-color: var(--color-border-light);
    cursor: not-allowed;
    opacity: 0.6;
  }

  &::placeholder {
    color: var(--color-text-muted);
    opacity: 0.7;
  }

  &:read-only {
    background: var(--color-background-disabled);
    cursor: default;
  }

  @media ${QUERIES.tabletAndDown} {
    font-size: var(--text-md);
    padding: 1rem;
  }
`;

const getCharacterCountColor = (props: {
  $isNearLimit?: boolean;
  $isOverLimit?: boolean;
}) => {
  if (props.$isOverLimit) return "var(--color-error)";
  if (props.$isNearLimit) return "var(--color-warning)";
  return "var(--color-text-tertiary)";
};

export const FooterRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
`;

export const CharacterCount = styled.div<{
  $isNearLimit?: boolean;
  $isOverLimit?: boolean;
}>`
  font-size: var(--text-xs);
  color: ${getCharacterCountColor};
  text-align: right;
  white-space: nowrap;
  flex-shrink: 0;
  font-weight: ${(props) => (props.$isNearLimit || props.$isOverLimit ? "600" : "400")};
  transition: color 0.2s ease;
`;

export const ErrorMessage = styled.span`
  display: block;
  color: var(--color-error);
  font-size: var(--text-xs);
  background: none;
  padding: 0;
  border: none;
  box-shadow: none;
  flex: 1;
`;
